import React from 'react';
import ConfirmWithCommentDialog, { ConfirmWithCommentPayload } from './ConfirmWithCommentDialog';
import { HelpBox } from '../help-boxes';

type Props = {
  isOpened: boolean;
  onClose(payload: ConfirmWithCommentPayload | null): void;
  // Name of the verification step to point the user to when a re-verification is needed (e.g.
  // "Step 3 - EPD Verification" in the old wizard, "Step 4 - EPD verification" in Dynamic Forms).
  // When omitted (Compiler) the step is not referenced.
  verificationStepName?: string;
};

const ConfirmEditorialSendToPublishProcessCertificationDialog: React.FC<Props> = ({
  isOpened,
  onClose,
  verificationStepName,
}) => {
  return (
    <ConfirmWithCommentDialog
      header="Send to publish"
      help={
        <HelpBox>
          <span>
            You are allowed to make editorial changes, such as correcting spelling errors, without updating the verification
            report.
          </span>
          <span>
            {verificationStepName
              ? `If the EPD information is updated, whether related to the product or LCA, you must update the verification report in "${verificationStepName}" again.`
              : 'If the EPD information is updated, whether related to the product or LCA, you must update the verification report.'}
          </span>
        </HelpBox>
      }
      inputLabelText="Changes description"
      primaryButtonText="Send"
      isOpened={isOpened}
      onClose={onClose}
      isCommentRequired
      closable={false}
    />
  );
};

export default ConfirmEditorialSendToPublishProcessCertificationDialog;
